import { render, staticRenderFns } from "./env.vue?vue&type=template&id=2fe9f15a&scoped=true"
import script from "./env.vue?vue&type=script&lang=js"
export * from "./env.vue?vue&type=script&lang=js"
import style0 from "./env.vue?vue&type=style&index=0&id=2fe9f15a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe9f15a",
  null
  
)

export default component.exports